import React, { useEffect, useState } from "react";
import MiniDrawer from "../../component/Layout1";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CustomButon from "../../component/Button";
import CustomDialog from "../../component/dailog/dailog";
import {
  createAdminNotification,
  deleteAdminNotification,
  getAllAdminNotification,
  updateAdminNotification,
} from "../../api/auth";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from "react-router-dom";

const Notification = () => {
  const [dialog, setDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    title: "",
    message: "",
  });
  const [notificationData, setNotificationData] = useState([]);
  const [selectedNotificationId, setSelectednotificationId] = useState(null);

  const onSubmit = async () => {
    const resp = await createAdminNotification({ formValues });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleEdit = (notify) => {
    setFormValues({
      title: notify.title,
      message: notify.message,
    });
    setSelectednotificationId(notify._id);
    setDialog(true);
  };

  const resetForm = () => {
    setFormValues({
      message: "",
      title: "",
    });
    setSelectednotificationId(null);
  };


  useEffect(() => {
    getAllNotification();
  }, [formValues]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (id) => {
    setSelectednotificationId(id)
    setOpen(true);
  };


  const updateNotification = async (id, { formValues }) => {
    try {
      const resp = await updateAdminNotification(id, { formValues });
      if (resp.remote === "success") {
        getAllAdminNotification();
      }
    }
    catch (error) {
      console.log('error.........', error);
    }
  };

  const getAllNotification = async () => {
    const resp = await getAllAdminNotification();
    if (resp.remote === "success") {
      setNotificationData(resp.data.data);
    }
  };

  const handleDelete = async (id) => {
    const resp = await deleteAdminNotification(id);
    if (resp.remote === "success") {
      setOpen(false);
      getAllNotification();
    }
  };

  return (
    <MiniDrawer>
      <Box>
        <Box
          sx={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
            Notification
          </Typography>
          <CustomButon onClick={() => setDialog(true)} variant="contained">
            Add
          </CustomButon>
        </Box>
        <Box className="FormBox" mb={3}>

          <TableContainer>
            <Table className="translation-table">
              <TableHead>
                <TableRow>
                  <TableCell>S.No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {notificationData.map((el, index) => (
                  <TableRow key={el._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{el.title}</TableCell>
                    <TableCell>{el.message}</TableCell>
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Link
                          onClick={() => handleEdit(el)}
                          className="btnLink"
                          style={{ background: "#CFFFE2", padding: "5px", borderRadius: "5px" }}
                        >
                          <EditIcon style={{ color: "#00BE4C" }} />
                        </Link>

                        <Link
                          onClick={() => handleClickOpen(el._id)}
                          className="btnLink"
                          style={{ background: "#FFDCDC", padding: "5px", borderRadius: "5px" }}
                        >
                          <DeleteIcon style={{ color: "#FF0000" }} />
                        </Link>
                        <Dialog open={open} onClose={handleClose}>
                          <DialogContent>
                            <Typography
                              style={{
                                fontWeight: 500,
                                fontSize: "18.51px",
                                lineHeight: "20.36px",
                              }}
                            >
                              Do you really want to remove the user?
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={() => handleDelete(selectedNotificationId)}
                              color="error"
                            >
                              Remove
                            </Button>
                          </DialogActions>
                        </Dialog>

                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Box>

        <Box className="FormBox" mb={3}>
          <CustomDialog
            open={dialog}
            onSave={() => {
              if (selectedNotificationId) {
                updateNotification(selectedNotificationId, { formValues })
              } else {
                onSubmit();
              }
              setDialog(false);
              resetForm();
              getAllAdminNotification();
            }}
            onClose={() => setDialog(false)}
          >
            <form>
              <Grid
                container
                spacing={2}
                sx={{
                  "& input": {
                    width: "100%",
                    padding: "10px ",
                    borderRadius: "5px",
                  },
                }}
              >
                <Grid item md={12}>
                  {" "}
                  <input
                    type="text"
                    placeholder="Title"
                    name="title"
                    value={formValues.title}
                    onChange={handleInputChange}
                  />

                </Grid>
                <Grid item md={12}>
                  {" "}
                  <input
                    type="text"
                    placeholder="message"
                    name="message"
                    value={formValues.message}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </form>
          </CustomDialog>
        </Box>
      </Box>
    </MiniDrawer>
  );
};

export default Notification;
